var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "10",
        viewBox: "0 0 10 10"
      }
    },
    [
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.color,
          "stroke-width": "2",
          d: "M.7071.70705L9.1761 9.17605M.7071 9.17585L9.1761.70685"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }